/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailIcon = ({ width = 24, height = 24, hidden = false, title = 'Email' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.75,2.99316H3.25c-1.24023,0-2.25,1.00977-2.25,2.25v9.5c0,1.24023,1.00977,2.25,2.25,2.25h13.5c1.24023,0,2.25-1.00977,2.25-2.25V5.24316c0-1.24023-1.00977-2.25-2.25-2.25ZM16.32935,4.49316l-5.83716,5.08301c-.2793.24414-.7041.24414-.98535,0L3.67065,4.49316h12.65869ZM16.75,15.49316H3.25c-.41309,0-.75-.33691-.75-.75V5.46191l6.02148,5.24512c.42188.36719.9502.55078,1.47852.55078s1.05664-.18359,1.47754-.55078l6.02246-5.24512v9.28125c0,.41309-.33691.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
